var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../../../src/ts/framework/Framework';
export class FileUploader {
    constructor(HTMLelement, sessionID) {
        this.filesToUpload = 0;
        this.filesUploaded = 0;
        this._files = [];
        if (HTMLelement.length > 0) {
            this.sessionID = sessionID;
            this.HTMLelement = HTMLelement;
            this.progressBar = this.HTMLelement.find('.hw-file-uploader-progress-bar');
            this.addEventListeners();
        }
    }
    addEventListeners() {
        // Prevent default drag behaviors
        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            this.HTMLelement.on(eventName, this.preventDefaults);
            $('body').on(eventName, this.preventDefaults);
        });
        // Highlight drop area when item is dragged over it
        ['dragenter', 'dragover'].forEach(eventName => {
            this.HTMLelement.on(eventName, () => {
                this.HTMLelement.addClass('is-highlighted');
            });
        });
        ['dragleave', 'drop'].forEach(eventName => {
            this.HTMLelement.on(eventName, () => {
                this.HTMLelement.removeClass('is-highlighted');
            });
        });
        this.HTMLelement.find('.hw-file-uploader-input').on('change', (event, field) => {
            if (field.files.length === 0)
                return;
            this.handleFiles(field.files);
        });
        // Handle dropped files
        this.HTMLelement.on('drop', (event) => {
            this.handleDrop(event);
        });
        // remove image from gallery
        $('body').on('click', '.hw-file-uploader-gallery-image-remove', (event, button) => {
            this.removeFile($(button).data('filename'));
        });
    }
    preventDefaults(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    handleDrop(event) {
        this.handleFiles(event.dataTransfer.files);
    }
    handleFiles(files) {
        return __awaiter(this, void 0, void 0, function* () {
            files = [...files];
            // If mime type is not jpg, gif or png, alert the user
            const hasWrongMimeType = files.some((file) => {
                const mimeType = file.type.split('/')[0];
                return mimeType !== 'image';
            });
            if (hasWrongMimeType)
                return;
            // If more than 5 files, alert the user
            if (this._files.length + files.length > 5) {
                let text = 'Vous ne pouvez pas télécharger plus de 5 fichiers à la fois.';
                if ($('body').attr('data-lang') == 'de')
                    text = 'Sie können nicht mehr als 5 Dateien gleichzeitig hochladen.';
                if ($('body').attr('data-lang') == 'en')
                    text = 'You cannot upload more than 5 files at once.';
                if ($('body').attr('data-lang') == 'it')
                    text = 'Non puoi caricare più di 5 file alla volta.';
                alert(text);
                return;
            }
            // Check file size
            let hasTooLargeFile = false;
            let isLoaded = [];
            let start = (new Date).getTime();
            files.forEach((file, index) => {
                const filesize = ((file.size / 1024) / 1024);
                if (filesize > 20)
                    hasTooLargeFile = true;
                if (filesize > 4) {
                    // resize the image to a smaller size using canvas
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    const img = new Image();
                    img.onload = () => {
                        const MAX_WIDTH = 3800;
                        const MAX_HEIGHT = 3800;
                        let width = img.width;
                        let height = img.height;
                        if (width > height) {
                            if (width > MAX_WIDTH) {
                                height *= MAX_WIDTH / width;
                                width = MAX_WIDTH;
                            }
                        }
                        else {
                            if (height > MAX_HEIGHT) {
                                width *= MAX_HEIGHT / height;
                                height = MAX_HEIGHT;
                            }
                        }
                        canvas.width = width;
                        canvas.height = height;
                        ctx.drawImage(img, 0, 0, width, height);
                        canvas.toBlob((blob) => {
                            files[index] = new File([blob], `canvas-${(new Date).getTime()}.jpg`, { type: 'image/jpeg' });
                            isLoaded[index] = true; // mark as loaded after resizing
                            console.log(`Image resized: ${files[index].name}, size: ${files[index].size / 1024 / 1024} MB`);
                        }, 'image/jpeg', 0.75);
                    };
                    isLoaded[index] = false;
                    img.src = URL.createObjectURL(file);
                }
                else {
                    isLoaded[index] = true; // mark as loaded if no resizing is needed
                }
            });
            // await for the image to be loaded
            const waitForImageLoad = () => {
                return new Promise((resolve) => {
                    const interval = setInterval(() => {
                        if (isLoaded.every((loaded) => loaded)) {
                            clearInterval(interval);
                            resolve(true);
                        }
                    }, 100);
                });
            };
            yield waitForImageLoad();
            console.log(`All images loaded in ${(new Date).getTime() - start} ms`);
            if (hasTooLargeFile) {
                let text = 'Fichier trop volumineux. Les fichiers ne doivent pas dépasser 20Mo.';
                if ($('body').attr('data-lang') == 'de')
                    text = 'Datei zu groß. Dateien dürfen nicht größer als 20 MB sein.';
                if ($('body').attr('data-lang') == 'en')
                    text = 'File too large. Files must not exceed 20MB.';
                if ($('body').attr('data-lang') == 'it')
                    text = 'File troppo grande. I file non devono superare i 20 MB.';
                alert(text);
                return;
            }
            this.initializeProgress(files.length);
            files.forEach((file, index) => {
                this.uploadFile(file, index);
            });
        });
    }
    initializeProgress(filesToUpload) {
        this.filesToUpload = filesToUpload;
        this.filesUploaded = 0;
        this.progressBar.removeClass('is-hidden').find('.progress-bar').get(0).style.width = '1%';
    }
    updateProgress() {
        this.filesUploaded++;
        const value = 100 / this.filesToUpload * this.filesUploaded;
        this.progressBar.find('.progress-bar').get(0).style.width = `${value}%`;
        if (value === 100) {
            $(this.HTMLelement).trigger('file-updated', { fileCount: this._files.length });
            setTimeout(() => {
                this.progressBar.addClass('is-hidden').find('.progress-bar').get(0).style.width = `0%`;
            }, 1000);
        }
    }
    uploadFile(file, i) {
        return __awaiter(this, void 0, void 0, function* () {
            $(this.HTMLelement).trigger('file-uploading');
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'automatic_identification_image_upload',
                    session_id: this.sessionID,
                    file: file
                },
                dataType: 'json'
            });
            if (response.status === 'success') {
                this._files.push(response.filename);
                this.checkFileCount();
                this.updateProgress();
                this.previewFile(file, response.filename);
            }
            else {
                alert('Une erreur est survenue lors du téléchargement de votre fichier.');
            }
        });
    }
    checkFileCount() {
        if (this._files.length >= 5) {
            this.HTMLelement.find('.hw-file-uploader-btn').addClass('d-none');
        }
        else {
            this.HTMLelement.find('.hw-file-uploader-btn').removeClass('d-none');
        }
    }
    previewFile(file, filename) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.addEventListener('loadend', () => {
            const img = $.parseHTML(`<div class="hw-file-uploader-gallery-image" style="background-image:url(${reader.result});"><div class="hw-file-uploader-gallery-image-crop" data-original-filename="${filename}"></div><div class="hw-file-uploader-gallery-image-remove" data-filename="${filename}"></div></div>`);
            this.HTMLelement.find('.hw-file-uploader-gallery').prepend(img);
        });
    }
    removeFile(filename) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: {
                    action: 'automatic_identification_image_remove',
                    session_id: this.sessionID,
                    filename: filename
                },
                dataType: 'json'
            });
            if (response.status === 'success') {
                this.HTMLelement.find(`.hw-file-uploader-gallery-image-remove[data-filename="${filename}"]`).parent().get(0).remove();
                this._files = this._files.filter((file) => file !== filename);
                this.checkFileCount();
            }
            else {
                alert('Une erreur est survenue lors de la suppression de votre fichier.');
            }
            $(this.HTMLelement).trigger('file-updated', { fileCount: this._files.length });
        });
    }
    get files() {
        return this._files;
    }
    reset() {
        this._files = [];
        this.filesUploaded = 0;
        this.filesToUpload = 0;
        this.HTMLelement.find('.hw-file-uploader-gallery-image').forEach((image) => {
            image.remove();
        });
        this.HTMLelement.find('.hw-file-uploader-btn').removeClass('d-none');
    }
    updateSessionID(sessionID) {
        this.sessionID = sessionID;
    }
    updateFile(originalFilename, filename) {
        const cropButton = this.HTMLelement.find(`.hw-file-uploader-gallery-image-crop[data-original-filename="${originalFilename}"]`);
        // update the background image of the parent element
        cropButton.parent().get(0).style.backgroundImage = `url(${window.location.origin}/wp-content/uploads/automatic-identification/${this.sessionID}/${filename})`;
        // update the file list
        this._files = this._files.map((file) => {
            if (file === originalFilename)
                return filename;
            return file;
        });
    }
}
